var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 22.5C42.5 34.1299 33.2902 43.5 22 43.5C10.7098 43.5 1.5 34.1299 1.5 22.5C1.5 10.8701 10.7098 1.5 22 1.5C33.2902 1.5 42.5 10.8701 42.5 22.5Z",
    stroke: "#29333C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93934 21.9393C8.35355 22.5251 8.35355 23.4749 8.93934 24.0607L18.4853 33.6066C19.0711 34.1924 20.0208 34.1924 20.6066 33.6066C21.1924 33.0208 21.1924 32.0711 20.6066 31.4853L12.1213 23L20.6066 14.5147C21.1924 13.9289 21.1924 12.9792 20.6066 12.3934C20.0208 11.8076 19.0711 11.8076 18.4853 12.3934L8.93934 21.9393ZM34 21.5L10 21.5V24.5L34 24.5V21.5Z",
    fill: "#29333C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.b7b697c092a3a95d69350c5cd2a21494.svg";
export { ForwardRef as ReactComponent };